"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function logOut() {
    localStorage.removeItem("cw-profile-new");
}
exports.logOut = logOut;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-my-page/utils.ts